// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.box {
  border-radius: 15px;
  padding: 1rem;
  margin: 15px;
  background-color: white;
  box-shadow: 0 0px 5px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stringBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding-left: 1%;
  padding-right: 1%;
  margin-bottom: 10px;
}

p {
  margin: 0;
}

.chart-container {
  margin: auto;
  height: auto;
  width: auto;
}

ion-item {
  margin-top: 7px;
}

ion-accordion-group {
  --ion-background-color: #F4F5F8;
}

.objective {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 5px;
  border-radius: 7px;
  background-color: rgb(243, 243, 243);
  margin-bottom: 1em;
}

.progress {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(243, 243, 243);
  padding: 15px;
  border-radius: 7px;
  margin-bottom: 5px;
}

.progress p {
  font-size: 15px;
}

.success-banner {
  background-color: #4caf50;
  /* Vert pour la réussite */
  color: white;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 12px;
  border-radius: 8px;
  margin: 16px;
  animation: fadeIn 0.8s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/objective-client/objective-page/objective-page.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,iFAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAEJ;;AACA;EACI,SAAA;AAEJ;;AACA;EACI,YAAA;EACA,YAAA;EACA,WAAA;AAEJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,+BAAA;AACJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;AAAJ;;AAGA;EACI;IACI,UAAA;IACA,4BAAA;EAAN;EAGE;IACI,UAAA;IACA,wBAAA;EADN;AACF","sourcesContent":[".box {\r\n    border-radius: 15px;\r\n    padding: 1rem;\r\n    margin: 15px;\r\n    background-color: white;\r\n    box-shadow: 0 0px 5px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.stringBox {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    text-align: center;\r\n    padding-left: 1%;\r\n    padding-right: 1%;\r\n    margin-bottom: 10px;\r\n}\r\n\r\np {\r\n    margin: 0;\r\n}\r\n\r\n.chart-container {\r\n    margin: auto;\r\n    height: auto;\r\n    width: auto;\r\n\r\n}\r\n\r\nion-item {\r\n    margin-top: 7px;\r\n}\r\n\r\nion-accordion-group {\r\n    --ion-background-color: #F4F5F8;\r\n\r\n}\r\n\r\n.objective {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: 5px;\r\n    border-radius: 7px;\r\n    background-color: rgb(243, 243, 243);\r\n    margin-bottom: 1em\r\n}\r\n\r\n.progress {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: rgb(243, 243, 243);\r\n    padding: 15px;\r\n    border-radius: 7px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.progress p {\r\n    font-size: 15px;\r\n}\r\n\r\n.success-banner {\r\n    background-color: #4caf50;\r\n    /* Vert pour la réussite */\r\n    color: white;\r\n    text-align: center;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    padding: 12px;\r\n    border-radius: 8px;\r\n    margin: 16px;\r\n    animation: fadeIn 0.8s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-20px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
